var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18 8.83L0.542997 2.203C-0.108003 1.275 0.555997 0 1.689 0L10.311 0C11.444 0 12.108 1.275 11.458 2.203L6.819 8.83C6.72678 8.96163 6.60419 9.06909 6.46163 9.14328C6.31906 9.21747 6.16071 9.25621 6 9.25621C5.83928 9.25621 5.68093 9.21747 5.53837 9.14328C5.3958 9.06909 5.27221 8.96163 5.18 8.83Z",
    fill: "#089D49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret-down.f16c1d4a4ec7dfe04b99d650ab0497c6.svg";
export { ForwardRef as ReactComponent };